import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Unsubscriber } from 'src/app/core/extenders/unsubscriber';
import { UserRequest, UserRequestsE } from 'src/app/core/models/user.model';
import { catchError, finalize, throwError } from 'rxjs';

import { ActivityService } from 'src/app/core/services/activity.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { FormValidationService } from 'src/app/core/services/form-validation.service';

@Component({
  selector: 'hch-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent extends Unsubscriber implements OnInit {
  form: FormGroup;
  title = '';
  description = '';
  submitting = false;
  focusIdOnClose?: string;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private authService: AuthService,
    private activityService: ActivityService,
    private formValidationService: FormValidationService
  ) {
    super();

    this.form = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, this.formValidationService.nameValidator()])],
      lastName: ['', Validators.compose([Validators.required, this.formValidationService.nameValidator()])],
      email: ['', Validators.compose([Validators.required, this.formValidationService.emailValidator()])],
      phone: ['', Validators.compose([Validators.required, this.formValidationService.phoneNumberValidator()])],
      message: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.title = 'Get Support';
    this.addSubscription = this.authService.currentUser.subscribe((user) => {
      if (user) {
        const [firstName, lastName] = user.fullName.split(' ');
        // Do not patch value if a value already exists in the form:
        if (
          this.firstName?.value.length == 0 &&
          this.lastName?.value.length == 0 &&
          this.email?.value.length == 0 &&
          this.phone?.value.length == 0
        ) {
          this.form.patchValue({
            firstName,
            lastName,
            email: user.email,
            phone: user.phoneNumber.replace(/[^0-9]+/g, ''),
          });
        }
        this.description = 'Our concierge will contact you soon!';
      } else {
        this.description = 'How can we help you? Let us know, and your concierge will contact you.';
      }
    });
  }

  get firstName() {
    return this.form.get('firstName');
  }
  get lastName() {
    return this.form.get('lastName');
  }
  get phone() {
    return this.form.get('phone');
  }
  get email() {
    return this.form.get('email');
  }
  get message() {
    return this.form.get('message');
  }

  onSubmit() {
    if (this.form.invalid) return;
    this.submitting = true;
    let data: UserRequest = {
      // jungoId: this.currentUser.jungoId,
      firstName: this.firstName?.value,
      lastName: this.lastName?.value,
      email: this.email?.value,
      phone: this.phone?.value,
      message: this.message?.value,
    };

    let hasError = false;

    this.addSubscription = this.activityService
      .sendRequest(UserRequestsE.GET_SUPPORT, data)
      .pipe(
        catchError((error) => {
          hasError = true;
          document.getElementById('close-request-modal')?.focus();

          return throwError(() => error);
        }),
        finalize(() => {
          this.form.reset();
          this.submitting = false;
          // Display confirmation modal
          this.bsModalRef.hide();
          this.activityService.displayConfirmationModal(hasError);
        })
      )
      .subscribe();
  }

  closeModal() {
    this.bsModalRef.hide();
    if (this.focusIdOnClose) {
      document.getElementById(this.focusIdOnClose)?.focus();
    } else document.getElementById('hamburger-icon')?.focus();
  }
}
